import React, { Component } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import TabBox from './../../components/TabBox';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from "./styles/about.js";

class About extends Component {

    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper about-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcrumb */}
                    <BreadcrumbBox title="Why Choose Us" bgImage="globalAbroad/logo_black_for_cover.png" />

                    {/* About Area */}
                    <AboutUs />

                    {/* Tab Section */}
                    <TabBox />

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default About;